var _g;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6A1.5 1.5 0 0 1 5 8.914V9.5a5.5 5.5 0 0 0 5.5 5.5H13v-1.5l3 2-3 2V16h-2.5A6.5 6.5 0 0 1 4 9.5v-.585A1.5 1.5 0 0 1 4.5 6M8 0l.018.018V0L11 2.987h-.014L11 3v2H9.999V2.991L8.019 3l-.001-2H1v12h3l.7 1H.996A1 1 0 0 1 0 12.993V1.007A1 1 0 0 1 .996 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 6 1 1h-.004l1.003 1.007V8L20 9v9.993A1 1 0 0 1 19.004 20H9.996A1 1 0 0 1 9 18.993V7.007A1 1 0 0 1 9.996 6zm0 1h-7v12h9l-.001-9.985-1.999.01z"
  }))));
});
const SvgBillToPoIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBillToPoIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNNC41IDZBMS41IDEuNSAwIDAgMSA1IDguOTE0VjkuNWE1LjUgNS41IDAgMCAwIDUuNSA1LjVIMTN2LTEuNWwzIDItMyAyVjE2aC0yLjVBNi41IDYuNSAwIDAgMSA0IDkuNXYtLjU4NUExLjUgMS41IDAgMCAxIDQuNSA2ek04IDBsLjAxOC4wMThWMEwxMSAyLjk4N2gtLjAxNEwxMSAzdjJIOS45OTlWMi45OTFMOC4wMTkgM2wtLjAwMS0ySDF2MTJoM2wuNyAxSC45OTZBMSAxIDAgMCAxIDAgMTIuOTkzVjEuMDA3QTEgMSAwIDAgMSAuOTk2IDBIOHoiLz4KICAgICAgICA8cGF0aCBkPSJtMTcgNiAxIDFoLS4wMDRsMS4wMDMgMS4wMDdWOEwyMCA5djkuOTkzQTEgMSAwIDAgMSAxOS4wMDQgMjBIOS45OTZBMSAxIDAgMCAxIDkgMTguOTkzVjcuMDA3QTEgMSAwIDAgMSA5Ljk5NiA2SDE3em0wIDFoLTd2MTJoOWwtLjAwMS05Ljk4NS0xLjk5OS4wMVY3eiIvPgogICAgPC9nPgo8L3N2Zz4K";